// frontend/src/components/common/PageBanner.jsx
//
// The one shape of a page banner: what on this page needs the merchant's
// attention right now. A page renders it at the top — above its tile, or
// inside the tile above the filters — and the container's gap spaces it, so
// it carries no margin of its own. An outcome of something the merchant just
// did is a toast (`showToast`), not a banner.
//
// `messages` holds one sentence per condition and `actions` one next step
// each — `{ label, onClick }`, or `{ label, href }` for a step that leaves the
// app (a real link, so it opens like one); a falsy entry in either is a condition
// that does not hold. With no message left the banner renders nothing — so a
// page lists its conditions once instead of also OR-ing them into a show
// flag. Every message must come from one server answer: rows read at two
// moments can contradict each other on screen.

import { Alert, Button, Typography } from '@mui/material';
import AlertActionSlot from './AlertActionSlot';

export default function PageBanner({ severity, messages, actions = [], onDismiss }) {
  const shown = messages.filter(Boolean);
  if (shown.length === 0) return null;
  const steps = actions.filter(Boolean);
  const hasActionSlot = steps.length > 0 || Boolean(onDismiss);

  return (
    <Alert
      severity={severity}
      // With an action slot, no right padding: the buttons and the X end on
      // the content column, level with the tile's header buttons.
      sx={hasActionSlot ? { pr: 0 } : undefined}
      action={hasActionSlot && (
        <AlertActionSlot onDismiss={onDismiss}>
          {steps.map(({ label, onClick, href }) => (
            <Button key={label} variant="outlined" onClick={onClick} href={href}>{label}</Button>
          ))}
        </AlertActionSlot>
      )}
    >
      {shown.map((message, index) => (
        <Typography key={index} variant="body2">{message}</Typography>
      ))}
    </Alert>
  );
}
